<template>
    <div class="row" style="padding: 12px">
        <div class="col-md-12 p-0">
            <div class="card table-card">
                <div class="card-block" style="padding: 0">
                    <div class="table-responsive" style="overflow-x: inherit">
                        <table
                            class="table table-hover mb-0"
                            style="margin-bottom: 2rem"
                        >
                            <thead>
                                <tr>
                                    <th style="padding: 4px 0px 4px 20px">
                                        Používateľ (e-mail)
                                    </th>
                                    <th style="padding: 4px 0px 4px 20px">
                                        Priemerná cena ponúk
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in data" :key="user.email">
                                    <td style="padding: 4px 0px 4px 20px">
                                        <div
                                            class="d-inline-block align-middle"
                                        >
                                            <div class="d-inline-block">
                                                <h6>{{ user.email }}</h6>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="padding: 4px 0px 4px 20px">
                                        <div
                                            class="d-inline-block align-middle"
                                        >
                                            <div class="d-inline-block">
                                                <h6>
                                                    {{
                                                        formatNumber(
                                                            user.avg_offer_price
                                                        )
                                                    }}
                                                    €
                                                </h6>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["data"],
    methods: {
        formatNumber(value) {
            return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
    },
};
</script>

<style lang="scss">
.create_klient {
    width: 230px;
    height: 55px;
    @media only screen and (max-width: 600px) {
        margin-top: 25px;
        width: 280px;
        float: left;
    }
    background: #2ed8b6;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #ffffff;
    cursor: pointer;
    transition: 0.5s all;
    float: right;
    &:hover {
        background: #23caa9;
        color: #ffffff;
    }
    &.disabled {
        cursor: no-drop;
        pointer-events: none;
        opacity: 0.3;
    }
}
</style>
<style lang="scss" scoped>
td,
th {
    white-space: normal !important;
}
</style>
